import React, { useState, useEffect } from 'react';
import { Col } from 'react-bootstrap';

const Pvideo = () => {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const handleChange = (e) => setIsDesktop(e.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // No renderizamos el iframe en mobile: dejarlo oculto con CSS (d-none)
  // no detiene su reproduccion/audio en segundo plano.
  if (!isDesktop) {
    return null;
  }

  return (
    <div className='mt-3 d-none d-md-block'
      style={{
        height: '100vh',
        width: '100%',
        position: 'relative',
        backgroundColor: '#FFF',
      }}
    >
        <div className="h-100 align-items-center justify-content-center">
          <Col md={12} className="h-100">
            <div
              style={{
                position: 'relative',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
              }}
            >
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
                src="images/video-home.mp4"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
        </div>
    </div>
  );
};

export default Pvideo;
